import { connect, mapProps, mapReadPretty } from '@formily/react'
import { Checkbox as AntdCheckbox } from 'antd'

export const Checkbox = connect(
  AntdCheckbox,
  mapReadPretty(AntdCheckbox, {
    disabled: true
  }),
  mapProps({
    value: 'checked'
  })
)

export const CheckboxGroup = connect(
  AntdCheckbox.Group,
  mapReadPretty(AntdCheckbox.Group, {
    disabled: true
  }),
  mapProps({
    dataSource: 'options'
  })
)
